export const VueGradient = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <g clipPath="url(#clip0_271_6303)">
        <path
          d="M15.4166 2.0625L12.6666 6.875L9.91663 2.0625H0.666626L12.6666 22.875L24.6666 2.0625H15.4166Z"
          fill="url(#paint0_linear_271_6303)"
        />
        <path
          d="M15.4166 2.0625L12.6666 6.875L9.91663 2.0625H5.47913L12.6666 14.5625L19.8541 2.0625H15.4166Z"
          fill="#BEBECC"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_271_6303"
          x1="0.666626"
          y1="12.4688"
          x2="24.6666"
          y2="12.4688"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD2476" />
          <stop offset="1" stopColor="#FF512F" />
        </linearGradient>
        <clipPath id="clip0_271_6303">
          <rect width="24" height="24" fill="white" transform="translate(0.666626)" />
        </clipPath>
      </defs>
    </svg>
  );
};
